export const roleConsts = {
  LOAD_REQUEST: '[Roles] LOAD_REQUEST',
  LOAD_FAILURE: '[Roles] LOAD_FAILURE',
  LOAD_SUCCESS: '[Roles] LOAD_SUCCESS'
};
